export default "<div>\n\t<img src=\"/assets/page_404.png\" class=\"logo_404\">\n</div>"